import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@src/store/base-query';

export const productsApi = createApi({
  reducerPath: 'productsQueries',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Products', 'Product'],
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: () => ({
        url: `stripe/products`,
        method: 'GET',
      }),
      providesTags: ['Products'],
    }),
    getProductById: builder.query({
      query: (id) => ({
        url: `stripe/products/${id}`,
        method: 'GET',
      }),
      providesTags: ['Product'],
    }),
  }),
});

export const { useGetProductsQuery, useGetProductByIdQuery } = productsApi;
